import React from "react";
import { useSelector } from "react-redux";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";

import Login from "./pages/login/Login";
import Sidebar from "./components/sidebar/Sidebar";
import Topbar from "./components/topbar/Topbar";

import Home from "./pages/home/Home";
import UserList from "./pages/userList/UserList";
import User from "./pages/user/User";
import UserTeams from "./pages/userTeams/UserTeams";
import Team from "./pages/team/Team";
import UserSubscriptionDetails from "./pages/userSubscriptionDetails";
import NewUser from "./pages/newUser/NewUser";
import GameRules from "./pages/gameRules/GameRules";
import RuleDetails from "./pages/ruleDetails/RuleDetails";
import AddRule from "./pages/addRule/AddRule";
import EditUser from "./pages/editUser/EditUser";
import AllSubscriptions from "./pages/allSubscriptions/AllSubscriptions";
import SubscriptionBundles from "./pages/subscriptionBundles/SubscriptionBundles";
import CreateBundle from "./pages/createBundle/CreateBundle";
import UpdateBundle from "./pages/updateBundle/UpdateBundle";
import GameCodes from './pages/gameCodes/GameCodes.jsx';
import StatsPage from "./pages/statsPage/StatsPage.jsx";
import StatsDetails from "./pages/statsDetails/StatsDetails.jsx";

import UserDashboard from "./user/pages/dashboard/UserDashboard.jsx"
import SelectTeam from "./user/pages/selectTeam/SelectTeam.jsx"
import GameLog from "./user/pages/gamelog/GameLog.jsx"
import GameLogDetails from "./user/pages/gamelogdetails/GameLogDetails.jsx"
import MyTeam from "./user/pages/myTeams/MyTeam.jsx"
import EditTeam from "./user/pages/editTeam/EditTeam.jsx"
import ScheduledGameDetails from "./user/pages/scheduledGameDetails/scheduledGameDetails.jsx";
import EditScheduledGame from "./user/pages/editScheduledGame/editScheduledGame.jsx";

import "./App.css";

function App() {
  const { isAuthenticated, isAdmin } = useSelector((state) => state.auth);

  return (
    <Router>
  
      {isAuthenticated ? (
        <>
           <Topbar /> 
           {/*   */}
          <div  style={{display:'flex'}}>
          {isAdmin && <Sidebar />}
            <Switch>
            <Route exact path="/" component={Home} />
                <Route path="/userlist" component={UserList} />
                <Route path="/user/:userId" component={User} />
                <Route path="/userTeams/:userId" component={UserTeams} />
                <Route path="/team/:subscriptionId" component={Team} />
                <Route path="/UserSubscriptionDetails/:subId" component={UserSubscriptionDetails} />
                <Route path="/newUser" component={NewUser} />
                <Route path="/gameRules" component={GameRules} />
                <Route path="/ruleDetails/:ruleId" component={RuleDetails} />
                <Route path="/addRule" component={AddRule} />
                <Route path="/editUser/:userId" component={EditUser} />
                <Route path="/allSubscriptions" component={AllSubscriptions} />
                <Route path="/subscriptionBundles" component={SubscriptionBundles} />
                <Route path="/createBundle" component={CreateBundle} />
                <Route path="/updateBundle/:id" component={UpdateBundle} />
                <Route path="/gamecodes" component={GameCodes} />
                <Route path="/stats/:category" component={StatsPage} />
                <Route path="/statsDetails/:stats" component={StatsDetails} />
              <Route path="/userdashboard" component={UserDashboard} />
              <Route path="/selectteam" component={SelectTeam} />
              <Route exact path="/gamelog" component={GameLog} />
              <Route path="/gamelog/:logId" component={GameLogDetails} />
              <Route exact path="/myteam" component={MyTeam} />
              <Route exact path="/editteam" component={EditTeam} />
              {/* <Route  path="/scheduledgamedetails" component={ScheduledGameDetails} /> */}
              {/* <Route path="/editscheduledgame/:gameId" component={EditScheduledGame} /> */}
              <Route path="/editscheduledgame/:gameId" component={EditScheduledGame} />

              <Redirect to={isAdmin ? "/" : "/selectteam"} /> 
            </Switch>
          </div>
        </>
      ) : (
        <Switch>
          <Route path="/login" component={Login} />
          <Redirect to="/login" />
        </Switch>
      )}
    </Router>
  );
}

export default App;
